import { useEffect, useState } from 'react';

type Props = {
  element: HTMLElement | null;
  offset?: number;
  initialState?: boolean;
};

export const useVisibleElement = (
  { element, initialState, offset }: Props,
  callback?: (value: boolean) => void
) => {
  const [isVisible, setIsVisible] = useState(initialState ?? false);

  useEffect(() => {
    const checkVisibility = () => {
      if (!element) {
        setIsVisible(false);
        return;
      }

      const rect = element.getBoundingClientRect();
      const visible =
        rect.bottom + window.scrollY + (offset ?? 0) < window.scrollY;

      callback?.(visible);
    };

    checkVisibility();
    window.addEventListener('scroll', checkVisibility);
    window.addEventListener('resize', checkVisibility);

    return () => {
      window.removeEventListener('scroll', checkVisibility);
      window.removeEventListener('resize', checkVisibility);
    };
  }, [element]);

  return isVisible;
};
